import type { TableRow } from "../types/timeEfficiency.types";

function escapeCsv(value: unknown): string {
  const s = String(value ?? "");
  return /[",;\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function exportTableRowsToCsv(rows: TableRow[]): void {
  const headers = [
    "Projeto (MM)",
    "Nome do Evento",
    "Tipo de Evento",
    "Nº Participantes",
    "Cliente",
    "Status atual",
    "Entrou no status em",
    "Tempo no status (dias)",
    "Tempo total (dias)",
    "Início do projeto",
    "Criado em",
    "Justificativa",
    "Reaberturas",
  ];
  const linhas = rows.map((p) => [
    p.id,
    p.projeto,
    p.tipoEvento || "",
    p.numPessoas != null ? p.numPessoas : "",
    p.cliente,
    p.status,
    p.entrouEm,
    p.tempoNoStatus,
    p.tempoTotal,
    p.inicio,
    p.criacao,
    p.justificativa,
    p.reaberturas,
  ]);
  const csv =
    "﻿" +
    [headers, ...linhas].map((l) => l.map(escapeCsv).join(";")).join("\r\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  const hoje = new Date();
  const stamp = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(hoje.getDate()).padStart(2, "0")}`;
  a.href = url;
  a.download = `analise-tempo-eficiencia-mmidd-${stamp}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
